import React, { useEffect } from 'react';
import { X } from 'react-feather';

// redux
import { mapDispatchProps, mapStateToProps } from '../../store/store';
import { connect } from 'react-redux';
import Button from '../../components/button';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../routes';
import { PAYMENT_PRODUCT_TYPE } from 'constants/payment';
import { useLanguage } from '@languages/index';

interface PaymentComplete {
  title?: any;
  summary?: any;

  itemType: any;

  brand?: any;
  auth?: any;
  settings?: any;
  preferences?: any;

  setSheet?: (params?: any) => void;
  closeSheet?: () => void;

  setPopup?: (params?: any) => void;
  closePopup?: () => void;

  closeOverlays?: () => void;

  onConfirm?: () => void;
}

const PaymentComplete = (props: PaymentComplete) => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.payments };
  const navigate = useNavigate();

  const renderBody = () => {
    return (
      <div className="flex flex-row items-center pb-[50px] pt-[10px]">
        <div className="flex flex-col justify-center items-center gap-[10px] w-full">
          <div className="flex flex-row mx-auto">
            <img
              src="/assets/icons/ic-complete.svg"
              className="w-[48px] h-[48px]"
            />
          </div>
          <span className="text-[22px] font-bold text-center">
            {languageTexts.complete_text_10}
          </span>
          <span className="text-[15px] text-[#999999]">
            {languageTexts.complete_text_26}
          </span>
        </div>

        <div
          className="cursor-pointer items-center absolute right-0 top-0 m-[30px]"
          onClick={() => {
            props.closeOverlays();
          }}
        >
          <div>
            <X size={24} strokeWidth={1} />
          </div>
        </div>
      </div>
    );
  };

  const renderConfirmButton = () => {
    let confirmText = languageTexts.confirm;

    return (
      <div className="fixed md:relative md:w-auto bottom-0 left-0 right-0 form-submit-button">
        <Button
          style={{ borderRadius: 0 }}
          textColor={'WHITE'}
          buttonColor={'BLACK'}
          borderColor={'BLACK'}
          text={confirmText}
          onClick={() => {
            if (props.onConfirm) {
              props.closeOverlays();
              props.onConfirm();
            } else {
              props.closeOverlays();

              switch (props.itemType) {
                case PAYMENT_PRODUCT_TYPE.SEEDING:
                  navigate(ROUTES.PAYMENT_INDEX.PATH);
                  break;
              }
            }
          }}
        />
      </div>
    );
  };

  let containerStyle = '';
  if (props.preferences.isMobile) {
    containerStyle =
      'w-[100dvw] h-[100dvh] flex flex-col justify-start overflow-scroll bg-white px-5';
  } else {
    containerStyle =
      'relative w-[480px] flex flex-col justify-start rounded-2xl overflow-scroll p-[50px] bg-white';
  }

  return (
    <div className={`${containerStyle}`}>
      {renderBody()}
      {renderConfirmButton()}
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchProps)(PaymentComplete);
